import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ServicesProvider } from 'src/providers/services';

@Component({
  selector: 'app-pregnant-mother',
  templateUrl: './pregnant-mother.page.html',
  styleUrls: ['./pregnant-mother.page.scss'],
})
export class PregnantMotherPage implements OnInit {

  presentView: any;
  pregnantMother: boolean;
  pregnantWomen: boolean;

  childDevop: boolean;
  addMember: boolean;
  profileFlow: string;
  PatientProfile: any;
  nextVaccinDet: any;
  nextAppointment: any;
  vaccinList: any;

  constructor(public router: Router,
    private services: ServicesProvider,
  ) { }

  ngOnInit() {
  }

  doRefresh(event) {
    console.log('Begin async operation');

    setTimeout(() => {
      console.log('Async operation has ended');
      event.target.complete();
    }, 2000);
  }

  ionViewWillEnter() {
    this.presentView = "pregnantMother";
    this.pregnantMother = true;
    this.PatientProfile = null;
    //this.presentView="pregnantWomen";
    //this.pregnantWomen=true;
    this.childDevop = false;
    this.addMember = false;
    this.profileFlow = localStorage.getItem('profileFlow');
    this.getPatientProfile();
  }
  backToHome() {
    this.router.navigate(['/tabs/home']);
    this.pregnantMother = false;
    //this.pregnantWomen=false;
    this.childDevop = false;
    this.addMember = false;
  }

  openProfile() {
    this.router.navigate(['/tabs/profile']);
  }

  openMedication() {
    this.router.navigate(['/tabs/medication']);
  }

  openHealthTips() {
    this.router.navigate(['/tabs/health-tips']);
  }

  openPrescription() {
    this.router.navigate(['/tabs/pregmother-prescription']);
  }

  openAppointment() {
    this.router.navigate(['/tabs/appointments']);
  }

  openChildDevop() {
    this.presentView = "childDevop";
    this.childDevop = true;
    this.pregnantMother = false;
    //this.pregnantWomen=false;
    this.addMember = false;
    this.getVaccinList();
  }
  backToPregnantMother() {
    this.presentView = "pregnantMother";
    this.pregnantMother = true;
    //this.presentView="pregnantWomen";
    //this.pregnantWomen=true;
    this.childDevop = false;
    this.addMember = false;
  }

  openCamera() {
    this.router.navigate(['/tabs/camera']);
  }

  openGps() {
    this.router.navigate(['/tabs/gps']);
  }

  openAddmember() {
    this.presentView = "addMember";
    this.addMember = true;
    this.pregnantMother = false;
    //this.pregnantWomen=false;
    this.childDevop = false;
  }
  backToPegMom() {
    this.presentView = "pregnantMother";
    this.pregnantMother = true;
    //this.presentView="pregnantWomen";
    //this.pregnantWomen=true;
    this.childDevop = false;
    this.addMember = false;
  }

  getPatientProfile() {
    this.nextVaccinDet = null;
    this.nextAppointment = null;
    let currentDate = new Date(Date.now()).toISOString().split("T")[0];
    let currentTime = new Date(Date.now()).toLocaleTimeString().split(" ")[0];
    let requestdata = JSON.stringify({
      "patientId": localStorage.getItem("patient_id"),
      "currentDate": currentDate,
      "currentTime": currentTime
    });
    this.services.postRequest("getPatientProfile", requestdata).subscribe(response => {
      console.log("Patient Profile => ", response);
      this.PatientProfile = response.data[0];
      this.nextVaccinDet = this.PatientProfile.vaccinationList[0];
      this.nextAppointment = this.PatientProfile.patientNextAppointment[0];
      console.log(this.nextVaccinDet.profileImage);
    });
  }
  getVaccinList() {
    let apiData = JSON.stringify({
      "patientId": localStorage.getItem("patient_id"),
      "patientDoB": new Date(Date.now()).toISOString().split("T")[0]
    });
    this.services.postRequest("particularPatientVaccinationDetails", apiData).subscribe(res => {
      console.log(res);
      this.vaccinList=res.data[0];
      console.log(this.vaccinList);
    });
  }
}
